'use strict';
const processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./experience/components/commerce_assets/carouselWithContainer'));
});